import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=96201b6a&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=96201b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96201b6a",
  null
  
)

export default component.exports